

export class FullScreenEvent extends createjs.Event {
    public static FULL_SCREEN: string = "fullScreen";

    public static FULL_SCREEN_INTERACTIVE_ACCEPTED: string = "fullScreenInteractiveAccepted";

    private _fullScreen: boolean;
    private _interactive: boolean;

    constructor(type: string, bubbles: boolean = false, cancalable: boolean = false, fullScreen: boolean = false, interactive: boolean = false) {
        super(type, bubbles, cancalable);

        this._fullScreen = fullScreen;
        this._interactive = interactive;
    }

    public get fullScreen(): boolean {
        return this._fullScreen;
    }

    public get interactive(): boolean {
        return this._interactive;
    }

    /*override*/
    public clone(): FullScreenEvent {
        return new FullScreenEvent(this.type, this.bubbles, this.cancelable, this._fullScreen, this._interactive);
    }
}